/* eslint-disable @typescript-eslint/ban-ts-comment */
"use client";
import Image from "next/image";
import Link from "next/link";
import { useState, useEffect } from "react";

export interface Ranking {
  email: string | null;
  total: number | null;
  sessions: Session[] | null;
}

export interface Session {
  id: string;
  code: string;
  region: string;
  status: string;
  checkInOpen: boolean;
  showRanking: boolean;
  currentQuestionId: string;
  currentQuestionStartedAt: string;
  createdAt: string;
  updatedAt: string;
  game: Game;
  playerCount: number;
  answerCount: number;
  matchedPlayers: MatchedPlayer[];
}

export interface Game {
  id: string;
  title: string;
  model: string;
  playMode: string;
  screenMode: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  questionCount: number;
}

export interface MatchedPlayer {
  id: string;
  email: string;
  accountRole: string;
  name: string;
  score: number;
  joinedAt: string;
  _count: Count;
  totalResponseTimeSeconds: string;
}

export interface Count {
  answers: number;
}

export default function RankingProfile() {
  const [ranking, setRanking] = useState<Ranking>({
    email: null,
    total: null,
    sessions: null,
  });
  const [state, setState] = useState<string>("");

  useEffect(() => {
    // eslint-disable-next-line react-hooks/immutability
    getRanking();
  }, []);

  async function getRanking() {
    const email = localStorage.getItem("cazeemail");
    const region = localStorage.getItem("state");

    setState(region || "");

    if (!email) return;

    if (email) {
      const res = await fetch(`/api/ranking/?email=${email}`)?.then(
        async (x) => await x.json(),
      );
      setRanking(res);
    }
  }

  function renderDate(date: string) {
    return new Date(date)?.toLocaleDateString("pt-BR");
  }

  return (
    <div className="w-full pt-10 hidden">
      {state === "SP" && (
        <>
          <h1 className="font-extrabold text-[#2033ef] text-[20px] text-center">
            SUAS PONTUAÇÕES
          </h1>

          {ranking?.total === 0 && (
            <div className="bg-gray-200 p-5 rounded-sm mt-5">
              <h3 className="text-center font-bold">
                Ops! Você ainda não jogou...
              </h3>
            </div>
          )}

          {ranking?.total !== null && ranking.total >= 1 && (
            <div className="flex gap-2 flex-col mt-4">
              {ranking?.sessions?.map((i) => (
                <Link key={i.id} href={`/ranking/${i?.code}`}>
                  <div
                    key={i.id}
                    className="flex flex-col bg-[#2033ef] rounded-[10px] border-[#fec822] border-[2px]"
                  >
                    <div className="flex flex-row justify-between w-full p-2 items-center">
                      <div
                        className="flex flex-row justify-between w-[95%] items-center pb-2 p-2"
                        style={{
                          borderBottomColor: "#fec822",
                          borderBottomWidth: 1,
                        }}
                      >
                        <div>
                          <h3 className="font-bold text-white">
                            {i?.game.title}
                          </h3>
                        </div>
                        <div className="flex flex-col text-right">
                          <div>
                            <h3 className="text-[11px] text-white font-semibold">
                              PARTIDA: {i.code}
                            </h3>
                          </div>
                          <div>
                            <h3 className="text-[11px] text-white font-semibold">
                              {renderDate(i.createdAt)}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*row 2*/}
                    <div className="flex flex-row justify-between w-full p-3 items-center">
                      <div
                        className="flex flex-row justify-between w-[95%] items-center pb-2"
                        style={{
                          borderBottomColor: "#fec822",
                          borderBottomWidth: 1,
                        }}
                      >
                        <div className="flex flex-row gap-1 items-center">
                          <Image
                            src="/icons/star.svg"
                            alt="Pontuação"
                            height={16}
                            width={16}
                          />
                          <h3 className="font-bold text-white text-[13px]">
                            PONTUAÇÃO
                          </h3>
                        </div>
                        <div className="flex flex-col text-right">
                          <div>
                            <h3 className="text-[20px] text-white font-semibold">
                              {i.matchedPlayers?.[0]?.score || 0} pts
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*row 3*/}
                    <div className="flex flex-row justify-between w-full p-3 items-center">
                      <div className="flex flex-row justify-between w-[95%] items-center pb-2">
                        <div className="flex flex-row gap-2 items-center">
                          <Image
                            src="/icons/time.svg"
                            alt="Pontuação"
                            height={16}
                            width={16}
                          />
                          <h3 className="font-bold text-white text-[13px]">
                            TEMPO
                          </h3>
                        </div>
                        <div className="flex flex-col text-right">
                          <div>
                            <h3 className="text-[20px] text-white font-semibold">
                              {i.matchedPlayers?.[0]
                                ?.totalResponseTimeSeconds || 0}
                              {""}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
